import s from './CoreTable.module.scss';
import { flexRender, Table } from '@tanstack/react-table';
import { CSSProperties, HTMLAttributes } from 'react';

interface Props<TableData> extends HTMLAttributes<HTMLTableElement> {
  table: Table<TableData>;
  getHeaderStyles?: (headerId: string) => CSSProperties;
}

export function CoreTable<TableData extends object>({
  table,
  className,
  getHeaderStyles,
  ...rest
}: Props<TableData>) {
  return (
    <table
      data-testid="core-table-testid"
      className={[s.table, className].join(' ')}
      {...rest}
    >
      <thead>
        {table.getHeaderGroups().map((headerGroup) => (
          <tr className={s.headerRow} key={headerGroup.id}>
            {headerGroup.headers.map((header) => (
              <th
                style={{ ...getHeaderStyles?.(header.id) }}
                className={s.headerText}
                key={header.id}
              >
                <>
                  {header.isPlaceholder
                    ? null
                    : flexRender(header.column.columnDef.header, header.getContext())}
                </>
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody>
        {table.getRowModel().rows.map((row) => (
          <tr className={s.bodyRow} key={row.id}>
            {row.getVisibleCells().map((cell) => (
              <td key={cell.id}>
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
